import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-ef290452"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "note" }, [
  /*#__PURE__*/_createTextVNode(" カテゴリ名横のボタンを押すとカテゴリIDをコピーすることができます。"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" コピーした内容を直接Excelへ貼り付けてください。 ")
], -1))
const _hoisted_2 = { class: "custom-tree-node" }
const _hoisted_3 = { class: "mr10" }
const _hoisted_4 = { key: 0 }

import { ref, Ref, watch } from 'vue'
  import useClipboard from 'vue-clipboard3'
  import { ElMessage } from 'element-plus'
  import { QuestionCategory } from '@/types/question_category'
  import {  DocumentCopy } from '@element-plus/icons';


  interface Props {
    categories: QuestionCategory[]
  }
  
export default /*#__PURE__*/_defineComponent({
  props: {
    categories: { type: Array, required: true }
  },
  setup(__props: any) {

const props = __props as {
    categories: QuestionCategory[]
  }
  

  const { toClipboard } = useClipboard()

  const categoryProps = {
    children: "children",
    label: "name",
  };

  const successMessage: Ref<string> = ref('');

  watch(successMessage, () => {
    if (successMessage.value === "") {
      return;
    }
    ElMessage({
      showClose: true,
      message: successMessage.value,
      type: 'success'
    });
    successMessage.value = "";
  });

  const handleCopyToClicpboard = async (category: any) => {
    const id: string = category.id === 0 ? '' : String(category.id);
    const text: string = id + ":" + getCategoryPath(category.id, props.categories);
    await toClipboard(text);

    successMessage.value = 'クリップボードにカテゴリIDをコピーしました';
  };

  const getCategoryPath = (id: number, items: any[], basePath: string = ''): string => {
    for (const item of items) {
      const path = basePath + `/${item.name}`;

      if (item.id === id) {
        return path;
      }

      if (item.children) {
        const _path = getCategoryPath(id, item.children, path);
        if (path !== _path) {
          return _path;
        }
      }
    }

    return basePath;
  };

return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_tree = _resolveComponent("el-tree")!
  const _component_el_card = _resolveComponent("el-card")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _createVNode(_component_el_card, null, {
      default: _withCtx(() => [
        _createVNode(_component_el_tree, {
          data: __props.categories,
          props: categoryProps,
          "node-key": "id",
          "expand-on-click-node": false,
          "default-expand-all": "",
          "highlight-current": ""
        }, {
          default: _withCtx(({ data }) => [
            _createElementVNode("span", _hoisted_2, [
              _createElementVNode("span", _hoisted_3, _toDisplayString(data.name), 1),
              (data.id !== 0)
                ? (_openBlock(), _createElementBlock("span", _hoisted_4, [
                    _createVNode(_component_el_button, {
                      icon: _unref(DocumentCopy),
                      class: "button-minimini",
                      circle: "",
                      type: "primary",
                      onClick: ($event: any) => (handleCopyToClicpboard(data))
                    }, null, 8, ["icon", "onClick"])
                  ]))
                : _createCommentVNode("", true)
            ])
          ]),
          _: 1
        }, 8, ["data"])
      ]),
      _: 1
    })
  ], 64))
}
}

})